import createAsyncSlice from "../utils/createAsyncSlice";

const orders = createAsyncSlice({
  name: "orders",
  initialState: {
    data: [],
  },
});

export const fetchOrders = orders.asyncAction;
export const { resetState: resetOrdersState } = orders.actions;
export default orders.reducer;
